import { render, staticRenderFns } from "./ModuleViewBi.vue?vue&type=template&id=43c7f4ae&scoped=true"
import script from "./ModuleViewBi.vue?vue&type=script&lang=js"
export * from "./ModuleViewBi.vue?vue&type=script&lang=js"
import style0 from "./ModuleViewBi.vue?vue&type=style&index=0&id=43c7f4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c7f4ae",
  null
  
)

export default component.exports